module.exports = __webpack_public_path__ + "img/font@2x.e6430e05.png";